export const FETCH_PRODUCTION_ACCUMULATED_REQUEST = "FETCH_PRODUCTION_ACCUMULATED_REQUEST";
export const FETCH_PRODUCTION_ACCUMULATED_SUCCESS = "FETCH_PRODUCTION_ACCUMULATED_SUCCESS";
export const FETCH_PRODUCTION_ACCUMULATED_FAILURE = "FETCH_PRODUCTION_ACCUMULATED_FAILURE";

export const FETCH_IWO_GROUP_BY_ADDITIONAL_REQUEST = "FETCH_IWO_GROUP_BY_ADDITIONAL_REQUEST";
export const FETCH_IWO_GROUP_BY_ADDITIONAL_SUCCESS = "FETCH_IWO_GROUP_BY_ADDITIONAL_SUCCESS";
export const FETCH_IWO_GROUP_BY_ADDITIONAL_FAILURE = "FETCH_IWO_GROUP_BY_ADDITIONAL_FAILURE";

export const FETCH_JOB_HOURS_REQUEST = "FETCH_JOB_HOURS_REQUEST";
export const FETCH_JOB_HOURS_SUCCESS = "FETCH_JOB_HOURS_SUCCESS";
export const FETCH_JOB_HOURS_FAILURE = "FETCH_JOB_HOURS_FAILURE";
